var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDebica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.41 71.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d,.e{stroke-width:0px;}.e{fill:#ffc629;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 260.41,
    height: 71.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M15.94,25.95l-1.67-4.38,54.92-.09c12.53,0,17.26,5.08,15.24,13.75-1.84,8.23-10.42,14.37-19.71,14.37h-30.49l-1.75-4.38h15.24l.88-3.5h-20.5l-1.75-4.47h23.48l.88-3.41h-28.73l-1.66-4.38h44.15l-4.47,15.86h1.49c4.73,0,8.41-3.68,9.99-9.81,1.49-6.13-.61-9.55-4.9-9.55H15.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M130.94,45.63l2.17-8.07h1.48c2,0,2.46,1.23,1.66,4.29-.72,2.63-1.82,3.78-3.99,3.78h-1.32ZM134.17,33.61l2.16-8.07h.98c2.16,0,2.84,1.15,2.12,3.78-.85,3.19-1.95,4.29-4.29,4.29h-.98ZM124.74,21.51c.26.38.17.64-.04,1.4l-6.75,25.22c-.17.64-.26.89-.72,1.4h19.11c6.24,0,11-3.06,12.27-7.81,1.06-3.95-.55-5.95-4.88-6.84,1.91-.39,2.63-.64,3.4-1.02,2.2-.98,3.74-2.89,4.33-5.14,1.23-4.67-1.53-7.22-7.77-7.22h-18.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M162.1,21.51c.21.38.3.76.13,1.4l-6.75,25.22c-.17.64-.42.89-.89,1.4h13.16c-.17-.51-.13-.76.04-1.4l6.75-25.22c.17-.64.3-1.02.72-1.4h-13.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M213.31,22.37c-3.19-1.02-5.69-1.4-9.81-1.4-6.92,0-11.68,1.14-16.14,3.69-4.29,2.51-6.62,5.65-7.94,10.57-2.68,9.98,2.29,14.9,15.11,14.9,4.41,0,7.47-.38,11.76-1.66l1.57-5.82c-4.37,2.16-6.88,3.06-9.68,3.06-2.29,0-4.2-.89-5.31-2.42-1.49-1.74-1.61-4.29-.64-7.94,1.66-6.28,5.99-10.1,11.25-10.1,2.8,0,5.01.89,8.2,3.19l1.61-6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M224.14,38.14l5.65-8.07.94,8.07h-6.58ZM221.21,42.43h10.19l.94,5.69c.04.51.12.76.08,1.02-.04.13-.08.25-.3.38h14.01c-.43-.38-.51-.64-.64-1.4l-5.09-25.22c-.04-.38-.13-.76,0-1.15l.04-.25h-10.36c.13.13.13.25.13.25-.08.26-.34.64-.64,1.15l-18.47,25.22c-.51.76-.89,1.02-1.49,1.4h6.88c-.13-.13-.09-.25-.04-.38.04-.13.3-.51.59-1.02l4.16-5.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "109.31 53.11 97.96 53.11 97.03 56.62 108.41 56.62 109.31 53.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M94.24,21.51c.21.38.13.76-.04,1.4l-6.75,25.22c-.17.64-.26.89-.72,1.4h23.39l1.15-4.41q-.68.13-2.16.13h-8.54l2.08-7.81h8.88c1.02,0,1.14,0,1.78.13l1.14-4.29q-.72.21-2.04.21h-8.7l2.16-8.07h8.88c.64,0,1.15,0,1.78.12l1.06-4.03h-23.35Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebica);
export default __webpack_public_path__ + "static/media/debica.4ce263034bedc33e4b276f0e3ecf8cec.svg";
export { ForwardRef as ReactComponent };